import React, { Fragment } from "react"
import SEO from "../common/SEO.js"
import Nav from "../common/Nav.js"
import Hero from "../common/Hero.js"
import AboutMe from "../common/AboutMe.js"
import Works from "../common/Works.js"
import Recruiting from "../common/Recruiting.js"
import Footer from "../common/Footer.js"

export default function Home() {
  if (typeof window !== "undefined") {
    require("smooth-scroll")('a[href*="#"]')
  }
  return (
    <Fragment>
      <SEO />
      <Nav />
      <Hero />
      <AboutMe />
      <Works />
      <Recruiting />
      <Footer />
    </Fragment>
  )
}
